export default {
  // index
  profile: {
    english: "Profile",
    spanish: "Perfil"
  },
  edit: {
    english: "Edit",
    spanish: "Editar"
  },
  personalInfo: {
    english: "Personal Info",
    spanish: "Información personal"
  },
  myInfo: {
    english: "My Info",
    spanish: "Mi información"
  },
  insurance: {
    english: "Insurance",
    spanish: "Seguro"
  },
  physician: {
    english: "Physician",
    spanish: "Médico"
  },
  insuranceAndPhysician: {
    english: "Insurance and Physician",
    spanish: "Seguro y Médico "
  },
  security: {
    english: "Security",
    spanish: "Seguridad"
  },
  multifactorAuthentication: {
    english: "Multifactor Authentication",
    spanish: "Autenticación por Factor Multiple"
  },
  // orderSupplies  is listed in dashboard
  // info

  name: {
    english: "Name",
    spanish: "Nombre"
  },
  lastName: {
    english: "Last Name",
    spanish: "Apellido"
  },
  email: {
    english: "Email",
    spanish: "Correo electrónico"
  },
  primaryPhoneNumber: {
    english: "Primary Phone Number",
    spanish: "Número de teléfono primario"
  },
  secondaryPhoneNumber: {
    english: "Secondary Phone Number",
    spanish: "Número de teléfono secundario"
  },
  address: {
    english: "Address",
    spanish: "Dirección"
  },
  city: {
    english: "City",
    spanish: "Ciudad"
  },
  zipCode: {
    english: "Zip Code",
    spanish: "Código postal"
  },
  state: {
    english: "State",
    spanish: "Estado"
  },
  // eligibleForSupplies listed in order-form
  primaryLanguage: {
    english: "Primary Language",
    spanish: "Lenguaje primario"
  },
  englishOrSpanish: { english: "English", spanish: "Español" },
  //  insurance
  insurances: {
    english: "Insurances",
    spanish: "Seguros"
  },
  primaryInsurance: {
    english: "Primary Insurance",
    spanish: "Seguro primario"
  },
  secondaryInsurance: {
    english: "Secondary Insurance",
    spanish: "Seguro secundario"
  },
  tertiaryInsurance: {
    english: "Tertiary Insurance",
    spanish: "Seguro terciario"
  },
  groupNumber: {
    english: "Group Number",
    spanish: "Número de grupo"
  },
  policyNumber: {
    english: "Policy Number",
    spanish: "Número de póliza"
  },
  insurancePhoneNumber: {
    english: "Insurance Phone Number",
    spanish: "Número de teléfono del seguro"
  },
  policyStartDate: {
    english: "Policy Start Date",
    spanish: "Fecha de inicio de póliza"
  },
  policyEndDate: {
    english: "Policy End Date",
    spanish: "Fecha de fin de póliza"
  },
  guarantorRelationship: {
    english: "Guarantor Relationship",
    spanish: "Relación del garante"
  },
  guarantorName: {
    english: "Guarantor Name",
    spanish: "Nombre del garante"
  },
  guarantorDob: {
    english: "Guarantor DOB",
    spanish: "Fecha de nacimiento del garante"
  },
  insuranceStreetAddress: {
    english: "Insurance Street Address",
    spanish: "Dirección del seguro"
  },
  insuranceStreetAddress2: {
    english: "Insurance Street Address 2",
    spanish: "Dirección del seguro 2"
  },
  insuranceCity: {
    english: "Insurance City",
    spanish: "Ciudad del seguro"
  },
  insuranceState: {
    english: "Insurance State",
    spanish: "Estado del seguro"
  },
  insuranceZip: {
    english: "Insurance Zip",
    spanish: "Código postal del seguro"
  },
  //   physician
  noPhysicianInformation: {
    english: "No physician information found",
    spanish: "No se encontró información del médico"
  },
  npi: {
    english: "NPI",
    spanish: "NPI"
  },
  phoneNumber: {
    english: "Phone Number",
    spanish: "Número de teléfono"
  },
  streetAddress: {
    english: "Street Address",
    spanish: "Dirección"
  },
  streetAddress2: {
    english: "Street Address 2",
    spanish: "Dirección 2"
  },
  phone: {
    english: "Phone",
    spanish: "Teléfono"
  },
  fax: {
    english: "Fax",
    spanish: "Fax"
  },
  notes: {
    english: "Notes",
    spanish: "Notas"
  },
  editProfile: {
    english: "Edit Profile",
    spanish: "Editar perfil"
  },
  //   notification-settings-modal
  // questionnaires listed in dashboard
  // Change password Modal
  changePassword: {
    english: "Change Password",
    spanish: "Cambiar la contraseña"
  },
  resetPassword: {
    english: "Reset Password",
    spanish: "Restablecer la contraseña"
  },
  currentPassword: {
    english: "Current Password",
    spanish: "Contraseña actual"
  },
  newPassword: {
    english: "New Password",
    spanish: "Nueva contraseña"
  },
  newPasswordConfirmation: {
    english: "New Password Confirmation",
    spanish: "Confirmación de nueva contraseña"
  },
  submit: {
    english: "Submit",
    spanish: "Enviar"
  },
  passwordRequirements: {
    english:
      "Password must be at least 8 characters long with 1 number, 1 capital and 1 lowercase letter",
    spanish:
      "La contraseña debe tener al menos 8 caracteres con 1 número, 1 mayúscula y 1 minúscula"
  },
  passwordsDoNotMatch: {
    english: "Passwords do not match",
    spanish: "Las contraseñas no coinciden"
  },
  close: {
    english: "Close",
    spanish: "Cerrar"
  },
  // multifactor options
  useMultifactor: {
    english: "Use Multifactor Authentication",
    spanish: "Usar Autenticación por Factor Multiple"
  },
  useVerificationByText: {
    english: "Use verification code by text message",
    spanish: "Usar código de verificación por mensaje de texto"
  },
  verifyPhoneNumber: {
    english: "Verify phone number",
    spanish: "Verificar número de teléfono"
  },
  sendCode: {
    english: "Send Code",
    spanish: "Enviar Código"
  },
  verify: { english: "Verify", spanish: "Verificar" },
  required: {
    english: "Required",
    spanish: "Requerido"
  },
  currentPasswordRequired: {
    english: "Current Password is required",
    spanish: "La contraseña actual es requerida"
  },
  newPasswordRequired: {
    english: "New Password is required",
    spanish: "La nueva contraseña es requerida"
  },
  newPasswordConfirmationRequired: {
    english: "New Password Confirmation is required",
    spanish: "La confirmación de la nueva contraseña es requerida"
  },
  invalidPhoneNumber: {
    english: "Invalid Phone Number",
    spanish: "Número de teléfono inválido"
  },
  incorrectCode: {
    english: "Incorrect code, please try again",
    spanish: "Código incorrecto, por favor intenta de nuevo"
  },
  MFAUpdated: {
    english: "Multifactor Authentication Updated Successfully",
    spanish: "Autenticación por Factor Multiple fue actualizada exitosamente"
  },
  verificationCodeSent: {
    english: "Verification code sent",
    spanish: "Código de verificación enviado"
  },
  phoneVerificationSucceded: {
    english: "Phone Number Verification Succeded",
    spanish: "Verificación del número de teléfono exitosa"
  },
  alreadyVerified: {
    english: "Verified",
    spanish: "Verificado"
  },
  waiting: {
    english: "Re-send code in X seconds",
    spanish: "Reenvie el codigo en X segundos"
  },
  enterPhoneForMFA: {
    english: "Enter your mobile number to receive login codes by text message.",
    spanish: "Ingrese su número de celular para recibir códigos de inicio de sesión por mensaje de texto."
  },
  codeSentTo: {
    english: "A verification code was sent to {phone}.",
    spanish: "Se envió un código de verificación a {phone}."
  },
  changePhoneNumber: {
    english: "Change phone number",
    spanish: "Cambiar número de teléfono"
  },
  resendCode: {
    english: "Resend code",
    spanish: "Reenviar código"
  },
  verificationCode: {
    english: "Verification Code",
    spanish: "Código de verificación"
  },
  smsFailedError: {
    english: "Failed to send SMS. Please check the number and try again.",
    spanish: "No se pudo enviar el SMS. Por favor verifique el número e intente de nuevo."
  },
  pleaseSelect: {
    english: "Please select",
    spanish: "Por favor seleccione"
  },
  save: {
    english: "Save",
    spanish: "Guardar"
  },
  saving: {
    english: "Saving...",
    spanish: "Guardando..."
  },
  cancel: {
    english: "Cancel",
    spanish: "Cancelar"
  },
  error: {
    english: "Error",
    spanish: "Error"
  },
  failedToUpdateProfile: {
    english: "Failed to update profile. Please try again.",
    spanish: "Error al actualizar el perfil. Por favor intente de nuevo."
  }
};
